import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import { industries } from "@/data/industries";
import { seo } from "@/config/site";

export default function Industries() {
  return (
    <>
      <SEO
        title="Packaging Applications"
        description="Packaging applications across manufacturing, automotive, engineering, electronics and warehousing environments."
        canonical={`${seo.siteUrl}/industries`}
      />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <Overline>Packaging Applications</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-neutral-900">Where our packaging fits.</h1>
          <p className="mt-5 max-w-3xl text-neutral-600 leading-relaxed">
            Our packaging range supports common industrial packaging applications.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {industries.map((a) => (
            <div key={a.id} className="bg-white border border-neutral-200 p-6 rounded-sm" data-testid={`industry-${a.id}`}>
              <div className="font-heading text-lg font-semibold text-neutral-900">{a.name}</div>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{a.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
